type LanguageButtonsProps = {
  language: string | null | undefined;
  languageChange: React.InputHTMLAttributes<HTMLInputElement>["onChange"];
};

const LanguageButtons: React.FC<LanguageButtonsProps> = ({
  language,
  languageChange,
}) => {
  return (
    <div>
      <label>
        <input
          type="radio"
          name="lang"
          value="ja"
          checked={language === "ja"}
          onChange={languageChange}
        />
        日本語
      </label>
      <label>
        <input
          type="radio"
          name="lang"
          value="en"
          checked={language === "en"}
          onChange={languageChange}
        />
        English
      </label>
    </div>
  );
};

export default LanguageButtons;
